import { render, staticRenderFns } from "./FicheroMercado_General.vue?vue&type=template&id=134e7290"
import script from "./FicheroMercado_General.vue?vue&type=script&lang=js"
export * from "./FicheroMercado_General.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports